module.exports = function () {
    $(document).ready(function () {

        var max_fields = 10; //maximum input boxes allowed

        var email_wrapper = $(".input_email_fields_wrap"); //Fields email_wrapper
        var add_email_button = $(".add_email_field_button"); //Add button ID

        var file_wrapper = $(".input_file_fields_wrap"); //Fields file_wrapper
        var add_file_button = $(".add_file_field_button"); //Add button ID

        var $selectMarketSegment = $('.js-change-market-segment'),
            $TRs = $('.js-contact-tr'),
            $checkboxes = $('.js-contact-checkbox');

        $selectMarketSegment.on('change', function(){
           var $this = $(this),
               marketSegmentId = $this.find(":selected").val();

            if(!marketSegmentId){

                $TRs.each(function( index ) {
                    $(this).show();
                });

                $checkboxes.each(function( index ) {
                    $(this).removeAttr("disabled");
                });

            } else{

                $TRs.each(function( index ) {
                    $(this).hide();
                });

                $checkboxes.each(function( index ) {
                    $(this).attr("disabled", true);
                });

                var $TRsOfMarketSegment = $('.js-tr-market-segment-id-'+marketSegmentId),
                    $checkboxesOfMarketSegment = $('.js-checkbox-market-segment-id-'+marketSegmentId);

                $TRsOfMarketSegment.each(function( index ) {
                    $(this).show();
                });

                $checkboxesOfMarketSegment.each(function( index ) {
                    $(this).removeAttr("disabled");
                });

            }

        });

        /**
         * Email fields
         */
        var x = 0;
        $(add_email_button).click(function (e) { //on add input button click
            e.preventDefault();
            if (x < max_fields) { //max input box allowed
                x++; //text box increment
                $('#emailsCounter').val(x);
                $(email_wrapper).append('<div style="margin-bottom: 3px;"><input type="email" name="emails[]" class="form-control" required /><a href="#" class="remove_field">Remove</a></div>'); //add input box
            }
        });

        $(email_wrapper).on("click", ".remove_field", function (e) { //user click on remove text
            e.preventDefault();
            $(this).parent('div').remove();
            x--;
            $('#emailsCounter').val(x);
        });


        /**
         * Files fields
         */
        var y = 1;
        $(add_file_button).click(function (e) { //on add input button click

            e.preventDefault();
            if (y < max_fields) { //max input box allowed
                y++; //text box increment
                $('#filesCounter').val(y);
                $(file_wrapper).append('<div style="margin-bottom: 3px;"><input type="file" name="files[]" class="form-control" required /><a href="#" class="remove_field">Remove</a></div>'); //add input box
            }
        });

        $(file_wrapper).on("click", ".remove_field", function (e) { //user click on remove text
            e.preventDefault();
            $(this).parent('div').remove();
            y--;
            $('#filesCounter').val(y);
        });

    });
}();
